<div class="diagram">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 538 563">
    <g id="Cargo_Van" data-name="Cargo Van" transform="translate(-425 -111)">
      <text
        id="Cargo_Van-2"
        data-name="Cargo Van"
        transform="translate(683 124)"
        font-size="14"
        font-family="Roboto-Medium, Roboto"
        font-weight="500"
      >
        <tspan x="0" y="0">Cargo Van</tspan>
      </text>
      <g id="Elements" transform="translate(288.989 58.31)">
        <path
          id="Path_858"
          data-name="Path 858"
          d="M429.939,163.281"
          transform="translate(-52.498 -17.066)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_866"
          data-name="Path 866"
          d="M537.279,256.9s-1.514-13.611-7.587-17.434-24.85-13.157-65.669-13.157c0,0-48.82,1.5-58.519,13.194,0,0-9.812,4.985-9.006,27.456"
          transform="translate(-32.833 -54.077)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1113" data-name="Group 1113" transform="translate(373.111 167.611)">
          <path
            id="Path_867"
            data-name="Path 867"
            d="M419.449,232.436l5.205-3.6a10.667,10.667,0,0,1,7.189-8.8c6.7-2.324,21.921-6.072,23.346-4.573s3.673,3.673,3.673,3.673l18.666-.974"
            transform="translate(-419.449 -215.119)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_868"
            data-name="Path 868"
            d="M623.858,231.675l-5.205-3.444a10.238,10.238,0,0,0-7.189-8.411c-6.7-2.222-21.921-5.805-23.346-4.372s-3.673,3.512-3.673,3.512l-24.28-.8"
            transform="translate(-502.085 -215.119)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_869"
          data-name="Path 869"
          d="M416.681,229.5s.655-35.758,3.326-46.515"
          transform="translate(-44.712 -28.639)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_870"
          data-name="Path 870"
          d="M714.639,229.5s-.665-38.382-3-46.515"
          transform="translate(-217.929 -28.639)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_871"
          data-name="Path 871"
          d="M396.566,292.469l1.105.356s-3.4-23.289,66.419-23.014c0,0,70.1-2.361,73.284,22.658"
          transform="translate(-32.9 -79.591)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_872"
          data-name="Path 872"
          d="M424.739,292.146"
          transform="translate(-49.445 -92.743)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_873"
          data-name="Path 873"
          d="M471.259,289.238"
          transform="translate(-76.764 -91.035)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_879"
          data-name="Path 879"
          d="M540.714,295.155,537.49,330.8s.187,2.081-3.018,1.575c0,0-17.317-4.61-61-4.61,0,0-50.959,2.183-55.9,4.69,0,0-1.866.558-2.183-1.691s-2.792-35.608-2.792-35.608-.678-1.35,2.51-2.324,29.875-11.005,58.666-10.122C473.775,282.709,534.642,284.434,540.714,295.155Z"
          transform="translate(-42.28 -87.168)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_880"
          data-name="Path 880"
          d="M403.862,346.245l1.7-1.576-3.782-36.676s-2.8,3.43-2.559,7.29Z"
          transform="translate(-34.451 -102.048)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_881"
          data-name="Path 881"
          d="M722.358,345.877l-1.7-1.576,3.781-36.676a9.013,9.013,0,0,1,2.729,6.58Z"
          transform="translate(-223.225 -101.832)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_889"
          data-name="Path 889"
          d="M399.7,387.821l-5.189-5.248s-.759-20.84.047-21.664,1.864-.45,2.647,3S399.7,387.821,399.7,387.821Z"
          transform="translate(-31.501 -132.907)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_890"
          data-name="Path 890"
          d="M394.861,421.189l5.189,4.648.612,37.033s-.375,1.724-1.874,1.5-3.635-.15-3.879-3.149S394.861,421.189,394.861,421.189Z"
          transform="translate(-31.855 -168.524)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_891"
          data-name="Path 891"
          d="M384.5,493.959l-.037-3.794L382.8,489.1v-8.63l1.434-1.743-.028-3.2-3.036,2.98v12.4Z"
          transform="translate(-23.86 -200.429)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1118" data-name="Group 1118" transform="translate(497.828 217.081)">
          <path
            id="Path_893"
            data-name="Path 893"
            d="M726.672,387.821l5.188-5.248s.759-20.84-.047-21.664-1.864-.45-2.647,3S726.672,387.821,726.672,387.821Z"
            transform="translate(-724.585 -349.989)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_894"
            data-name="Path 894"
            d="M730.989,421.189l-5.188,4.648-.613,37.033s.375,1.724,1.874,1.5,3.636-.15,3.879-3.149S730.989,421.189,730.989,421.189Z"
            transform="translate(-723.713 -385.605)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_896"
          data-name="Path 896"
          d="M472.639,471.777l-2.924-34.031,29.236,1.562,1.124,31.485"
          transform="translate(-75.857 -178.247)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_897"
          data-name="Path 897"
          d="M620.495,471.777l2.924-34.031-29.236,1.562-1.124,31.485"
          transform="translate(-148.291 -178.247)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1119" data-name="Group 1119" transform="translate(373.816 247.528)">
          <path
            id="Path_900"
            data-name="Path 900"
            d="M429.28,463.132c1.274-14.393-6.644-45.279-6.644-45.279s-3.326-8.4,0-9c5.275-.6,4.47,1.35,4.47,1.35,8.5,28.363,7.8,55.923,7.8,55.923"
            transform="translate(-421.158 -408.742)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_901"
            data-name="Path 901"
            d="M427.941,413.016s7.96,31.185,7.96,49.327V665.815"
            transform="translate(-425.141 -411.252)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1120" data-name="Group 1120" transform="translate(480.486 247.528)">
          <path
            id="Path_902"
            data-name="Path 902"
            d="M679.613,466.13s-.7-27.561,7.8-55.923c0,0-.8-1.949,4.47-1.35,3.326.6,0,9,0,9s-7.918,30.886-6.644,45.279"
            transform="translate(-679.599 -408.742)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_903"
            data-name="Path 903"
            d="M694.825,413.016s-7.96,31.185-7.96,49.327V665.815"
            transform="translate(-683.866 -411.252)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <line
          id="Line_52"
          data-name="Line 52"
          y1="10.739"
          transform="translate(384.576 505.128)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_53"
          data-name="Line 53"
          y2="10.739"
          transform="translate(483.485 505.128)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_910"
          data-name="Path 910"
          d="M644.861,1100.286l-1.912,3.261L619.9,1104.9l-2.249-2.924"
          transform="translate(-162.732 -567.328)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_911"
          data-name="Path 911"
          d="M559.26,1104.4l.878,2.9H523.93l1.237-2.924"
          transform="translate(-107.695 -569.728)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_912"
          data-name="Path 912"
          d="M478.6,1102.565l-2.137,3.486-22.714-1.743-2.028-3.014"
          transform="translate(-65.292 -567.92)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_913"
          data-name="Path 913"
          d="M440.837,1063.6"
          transform="translate(-58.898 -545.783)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_914"
          data-name="Path 914"
          d="M445.2,1070.863"
          transform="translate(-61.458 -550.049)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_916"
          data-name="Path 916"
          d="M537.588,181.658s4.36-33-72.778-33.1c0,0-60.947-3.028-67.019,33.1"
          transform="translate(-33.619 -8.38)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_198"
          data-name="Rectangle 198"
          width="33.734"
          height="21.297"
          transform="translate(360.642 520.814) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_917"
          data-name="Path 917"
          d="M429.758,1044.609h1.054v-11.751"
          transform="translate(-52.392 -527.731)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_918"
          data-name="Path 918"
          d="M431.238,1011.983v-9.5h-.754"
          transform="translate(-52.818 -509.892)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_919"
          data-name="Path 919"
          d="M415.772,1044.834s1.8,1.518,1.8-11.976"
          transform="translate(-44.179 -527.731)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_920"
          data-name="Path 920"
          d="M417.571,1011.983s.619-8.321-1.8-9.5"
          transform="translate(-44.179 -509.892)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_921"
          data-name="Path 921"
          d="M394.648,1007.879s-.468-4.948,1.837-5.4"
          transform="translate(-31.751 -509.892)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_922"
          data-name="Path 922"
          d="M394.648,1043.483s-.468,7.422,1.837,7.365"
          transform="translate(-31.751 -533.97)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_200"
          data-name="Rectangle 200"
          width="33.734"
          height="21.297"
          transform="translate(486.172 520.814) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_923"
          data-name="Path 923"
          d="M702.953,1044.609H701.9v-11.751"
          transform="translate(-212.208 -527.731)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_924"
          data-name="Path 924"
          d="M701.9,1011.983v-9.5h.754"
          transform="translate(-212.208 -509.892)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_925"
          data-name="Path 925"
          d="M715.878,1044.834s-1.8,1.518-1.8-11.976"
          transform="translate(-219.361 -527.731)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_926"
          data-name="Path 926"
          d="M713.978,1011.983s-.619-8.321,1.8-9.5"
          transform="translate(-219.26 -509.892)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_927"
          data-name="Path 927"
          d="M736.894,1007.879s.469-4.948-1.837-5.4"
          transform="translate(-231.681 -509.892)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_928"
          data-name="Path 928"
          d="M736.894,1043.483s.469,7.422-1.837,7.365"
          transform="translate(-231.681 -533.97)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1122" data-name="Group 1122" transform="translate(407.288 311.44)">
          <line
            id="Line_59"
            data-name="Line 59"
            y1="46.132"
            x2="14.945"
            transform="translate(0 0)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
            opacity="0.11"
          />
          <line
            id="Line_60"
            data-name="Line 60"
            y1="46.132"
            x2="14.945"
            transform="translate(7.693 4.469)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
            opacity="0.11"
          />
          <line
            id="Line_61"
            data-name="Line 61"
            y1="46.132"
            x2="14.945"
            transform="translate(16.478 8.392)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
            opacity="0.11"
          />
          <line
            id="Line_62"
            data-name="Line 62"
            y1="46.132"
            x2="14.945"
            transform="translate(25.97 12.322)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
            opacity="0.11"
          />
          <line
            id="Line_63"
            data-name="Line 63"
            y1="46.132"
            x2="14.945"
            transform="translate(36.568 17.671)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
            opacity="0.11"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['fuel_flap'] || ''"
        [attr.data-name]="'exterior.cargo_van.fuel_flap' | translate"
      >
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="88"
          height="18"
          rx="9"
          transform="translate(516 442)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 442)"
        />
        <g class="arrow" id="Arrow">
          <path
            id="Path_475"
            data-name="Path 475"
            d="M6210.1,1088.317l-42.625-108.662H6157"
            transform="translate(-5552.199 -529.317)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_188"
            data-name="Ellipse 188"
            cx="3"
            cy="3"
            r="3"
            transform="translate(655 556)"
            fill="#696969"
          />
        </g>
        <rect
          class="parts"
          id="Fuel_Flap-2"
          data-name="Fuel Flap"
          width="8.354"
          height="4.801"
          rx="2.4"
          transform="translate(654.649 566.968) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Fuel_Flap-3"
          data-name="Fuel Flap"
          transform="translate(538 454)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.fuel_flap' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(588 453)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_stop_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.rht_stop_lamp' | translate"
      >
        <path
          class="parts"
          id="LFT_Stop_Lamp-2"
          data-name="LFT Stop Lamp"
          d="M389.239,1070.863l3.7,9.445a3.844,3.844,0,0,0,3.036,1.911h5.679l1.859-1.845s-3.758.627-4.453-3.74v-5.772h-9.819"
          transform="translate(260.392 -491.74)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="127"
          height="18"
          rx="9"
          transform="translate(478 510)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(587 510)"
        />
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Path_477"
            data-name="Path 477"
            d="M6206.385,1045.317l-39.643-65.662H6157"
            transform="translate(-5553.199 -460.317)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_190"
            data-name="Ellipse 190"
            cx="3"
            cy="3"
            r="3"
            transform="translate(650 582)"
            fill="#696969"
          />
        </g>
        <text
          id="LFT_Stop_Lamp-3"
          data-name="LFT Stop Lamp"
          transform="translate(511 522)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rht_stop_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(589 521)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_wind_screen'] || ''"
        [attr.data-name]="'exterior.cargo_van.rr_wind_screen' | translate"
      >
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="115"
          height="18"
          rx="9"
          transform="translate(488 576)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 576)"
        />
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_478"
            data-name="Path 478"
            d="M6240.777,979.656l-67.25,23.483H6157"
            transform="matrix(0.966, 0.259, -0.259, 0.966, -5086.574, -1974.506)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_187"
            data-name="Ellipse 187"
            cx="3"
            cy="3"
            r="3"
            transform="translate(685 585)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Wind_Screen-2"
          data-name="RR Wind Screen"
          d="M442.636,1078.673H545.124v6.522s-20.553,2.655-55.035,1.612l-49.252-1.612v-6.522Z"
          transform="translate(230.091 -496.326)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Wind_Screen-3"
          data-name="RR Wind Screen"
          transform="translate(507 588)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rr_wind_screen' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(588 587)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_hatch_door_lock'] || ''"
        [attr.data-name]="'exterior.cargo_van.lock' | translate"
      >
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="64"
          height="18"
          rx="9"
          transform="translate(538 629)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(585 629)"
        />
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_480"
            data-name="Path 480"
            d="M6269,979.656l-89.9,32H6157"
            transform="translate(-5552 -375.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_185"
            data-name="Ellipse 185"
            cx="3"
            cy="3"
            r="3"
            transform="translate(717 600)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Path_931"
          data-name="Path 931"
          d="M6193.652,2331.008l-8.4.256-9.314.348v1.863l9.314.509,8.4-.858Z"
          transform="translate(-5459 -1732)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <text
          id="Lock-2"
          data-name="Lock"
          transform="translate(556 642)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.cargo_van.lock' | translate }}</tspan>
        </text>
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(587 640)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['tires'] || ''"
        [attr.data-name]="'exterior.cargo_van.tyres' | translate"
        transform="translate(410 538)"
      >
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="79"
          height="18"
          rx="9"
          transform="translate(426 114)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Tyres-2"
          data-name="Tyres"
          transform="translate(448 126)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.tyres' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(426 114)"
        />
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(428 125)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['others'] || ''"
        [attr.data-name]="'exterior.cargo_van.other_1' | translate"
      >
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="80"
          height="18"
          rx="9"
          transform="translate(521 656)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Other_1-2"
          data-name="Other 1"
          transform="translate(545 668)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.other_1' | translate }}
          </tspan>
        </text>
        <ellipse
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          rx="11"
          ry="11"
          transform="translate(583 656)"
        />
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(585 668)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_stop_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.lft_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="127"
          height="18"
          rx="9"
          transform="translate(836 526)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 526)"
        />
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_465"
            data-name="Path 465"
            d="M6157,1033.11l36.123-53.455H6202"
            transform="translate(-5365.997 -446.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_183"
            data-name="Ellipse 183"
            cx="3"
            cy="3"
            r="3"
            transform="translate(788 584)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Stop_Lamp-5"
          data-name="LFT Stop Lamp"
          d="M724.795,1070.863l-3.7,9.445a3.844,3.844,0,0,1-3.036,1.911h-5.679l-1.859-1.845s3.758.627,4.453-3.74v-5.772h9.819"
          transform="translate(71.716 -491.74)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Stop_Lamp-6"
          data-name="LFT Stop Lamp"
          transform="translate(858 538)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.lft_stop_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(838 537)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['cargo_deck'] || ''"
        [attr.data-name]="'exterior.cargo_van.cargo_deck' | translate"
      >
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="127"
          height="18"
          rx="9"
          transform="translate(836 618)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 618)"
        />
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <circle
            id="Ellipse_229"
            data-name="Ellipse 229"
            cx="3"
            cy="3"
            r="3"
            transform="translate(719 557)"
            fill="#696969"
          />
          <path
            id="Path_537"
            data-name="Path 537"
            d="M6200,4896l98.979,68.74h14.431"
            transform="translate(-5478 -4336)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
        <path
          class="parts"
          id="Cargo_Deck-2"
          data-name="Cargo Deck"
          d="M6141.57,5001h101.158v-3.372h1.5V4779.416H6139.858v218.672h1.711Z"
          transform="translate(-5469 -4419)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <g id="Lines" transform="translate(688.861 457.231)">
          <line
            id="Line_54"
            data-name="Line 54"
            y2="103.17"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <line
            id="Line_55"
            data-name="Line 55"
            y2="103.17"
            transform="translate(16.363)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <line
            id="Line_56"
            data-name="Line 56"
            y2="103.17"
            transform="translate(32.726)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <line
            id="Line_57"
            data-name="Line 57"
            y2="103.17"
            transform="translate(49.089)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <line
            id="Line_58"
            data-name="Line 58"
            y2="103.17"
            transform="translate(65.452)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Cargo_Deck-3"
          data-name="Cargo Deck"
          transform="translate(858 630)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.cargo_deck' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(838 629)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_indicatot_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.rht_rr_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="133"
          height="18"
          rx="9"
          transform="translate(830 492)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 492)"
        />
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <circle
            id="Ellipse_182"
            data-name="Ellipse 182"
            cx="3"
            cy="3"
            r="3"
            transform="translate(778 583)"
            fill="#696969"
          />
          <path
            id="Path_464"
            data-name="Path 464"
            d="M6157,1065.11l44.789-85.455h11.005"
            transform="translate(-5376.792 -479.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
        <path
          class="parts"
          id="RHT_Indicator_lamp-2"
          data-name="RHT RR Indicator lamp"
          d="M690.944,1080.608v-6.522h-1.8v-3.223h13.276v5.772s-.375,3.715-3.715,3.715Z"
          transform="translate(84.27 -491.74)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(838 503)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Indicator_lamp-3"
          data-name="RHT RR Indicator lamp"
          transform="translate(858 504)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rht_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_panel'] || ''"
        [attr.data-name]="'exterior.cargo_van.rht_panel' | translate"
      >
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(836 434)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 434)"
        />
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_462"
            data-name="Path 462"
            d="M6157,1047.11l39.12-67.454h9.613"
            transform="translate(-5369.731 -537.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_181"
            data-name="Ellipse 181"
            cx="3"
            cy="3"
            r="3"
            transform="translate(784 507)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Panel-2"
          data-name="RHT Panel"
          d="M714.67,636.622l-.082-96.1H693.374V725.68h21.3l-.082-89.058Z"
          transform="translate(81.787 -180.291)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Panel-3"
          data-name="RHT Panel"
          transform="translate(858 446)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rht_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(838 445)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['cargo_sliding_door'] || ''"
        [attr.data-name]="'exterior.cargo_van.cargo_sliding_door' | translate"
      >
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="127"
          height="18"
          rx="9"
          transform="translate(836 344)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 344)"
        />
        <g class="parts" id="Cargo_Sliding_Door-2" data-name="Cargo Sliding Door">
          <g
            id="Rectangle_201"
            data-name="Rectangle 201"
            transform="translate(775 360)"
            fill="none"
            stroke="#000"
            stroke-width="0.5"
          >
            <rect width="22" height="67" stroke="none" />
            <rect x="0.25" y="0.25" width="21.5" height="66.5" fill="none" />
          </g>
          <path
            id="Path_932"
            data-name="Path 932"
            d="M745.228,494.065l.037-3.794,1.406-1.175v-8.63l-1.434-1.743.028-3.2,3.036,2.98v12.4Z"
            transform="translate(51.486 -112.12)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Cargo_Sliding_Door-3"
          data-name="Cargo Sliding Door"
          transform="translate(858 356)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.cargo_sliding_door' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_461"
            data-name="Path 461"
            d="M6157,1001.62l36.636-21.963h9"
            transform="translate(-5366.636 -627.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_179"
            data-name="Ellipse 179"
            cx="3"
            cy="3"
            r="3"
            transform="translate(787 371)"
            fill="#696969"
          />
        </g>
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(838 355)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rear_cargo_door'] || ''"
        [attr.data-name]="'exterior.cargo_van.rear_cargo_door' | translate"
      >
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="127"
          height="18"
          rx="9"
          transform="translate(664 651)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(664 651)"
        />
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_481"
            data-name="Path 481"
            d="M6157,979.656l.024,57h.005"
            transform="translate(-5429.5 -385.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_184"
            data-name="Ellipse 184"
            cx="3"
            cy="3"
            r="3"
            transform="translate(725 591)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Rear_Cargo_Door-2"
          data-name="Rear Cargo Door"
          d="M419.314,1095.754l1.859-1.846s51.553,1.958,56.276,1.846c0,0,50.922.262,55.035-1.612l7.025-.234,1.859,1.846S487.944,1101.788,419.314,1095.754Z"
          transform="translate(242.73 -505.273)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Rear_Cargo_Door-3"
          data-name="Rear Cargo Door"
          transform="translate(690 663)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rear_cargo_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(666 663)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['passenger_door_with_window'] || ''"
        [attr.data-name]="'exterior.cargo_van.passenger_door' | translate"
      >
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="109"
          height="18"
          rx="9"
          transform="translate(836 309)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 309)"
        />
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_460"
            data-name="Path 460"
            d="M6157,989.11l34.146-9.454h8.391"
            transform="translate(-5363.535 -662.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_178"
            data-name="Ellipse 178"
            cx="3"
            cy="3"
            r="3"
            transform="translate(790 324)"
            fill="#696969"
          />
        </g>
        <g
          class="parts"
          id="Passenger_Door-2"
          data-name="Passenger Door"
          transform="translate(786.816 275.391)"
        >
          <path
            id="Path_892"
            data-name="Path 892"
            d="M732,334.989l-.824,84.823h-9.535s-.853-86.06,7.661-84.823Z"
            transform="translate(-721.614 -334.976)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_895"
            data-name="Path 895"
            d="M744.971,493.959l.037-3.794,1.662-1.068v-8.63l-1.434-1.743.028-3.2,3.036,2.98v12.4Z"
            transform="translate(-735.331 -417.51)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Passenger_Door-3"
          data-name="Passenger Door"
          transform="translate(858 322)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.passenger_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(838 320)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_panel'] || ''"
        [attr.data-name]="'exterior.cargo_van.rht_front_panel' | translate"
      >
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="113"
          height="18"
          rx="9"
          transform="translate(836 234)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 234)"
        />
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_457"
            data-name="Path 457"
            d="M6157,984.11l30.5-4.454h7.5"
            transform="translate(-5359.998 -735.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_176"
            data-name="Ellipse 176"
            cx="3"
            cy="3"
            r="3"
            transform="translate(794 246)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Front_Panel-2"
          data-name="RHT Front Panel"
          d="M729.9,228.235s4.273,4.236,4.273,43.817h-2.7s.338-3.936-1.068-4.217c0,0,.956-26.088-4.666-37.108,0,0-1.068-2.024,0-2.811s2.305,2.642,3.711,8.265l.9.113Z"
          transform="translate(63.06 3.352)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Front_Panel-3"
          data-name="RHT Front Panel"
          transform="translate(858 246)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rht_front_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(838 245)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_head_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.rht_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="109"
          height="18"
          rx="9"
          transform="translate(836 170)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 170)"
        />
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_454"
            data-name="Path 454"
            d="M6157,1004.11l54.418-24.454h13.373"
            transform="translate(-5389.79 -802.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_174"
            data-name="Ellipse 174"
            cx="3"
            cy="3"
            r="3"
            transform="translate(764 199)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Head_Lamp-2"
          data-name="RHT Head Lamp"
          d="M680.259,164.866s.6-6.053-11.392-11.151-16.515-5.517-17.553-3.7C651.314,150.02,670.51,153.3,680.259,164.866Z"
          transform="translate(106.486 49.61)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Head_Lamp-3"
          data-name="RHT Head Lamp"
          transform="translate(858 182)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rht_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(838 181)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_grill'] || ''"
        [attr.data-name]="'exterior.cargo_van.frt_grill' | translate"
        transform="translate(1)"
      >
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="86"
          height="18"
          rx="9"
          transform="translate(836 111)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 111)"
        />
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_456"
            data-name="Path 456"
            d="M6157,1054.322l90.87-74.666h22.33"
            transform="translate(-5435.199 -860.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_171"
            data-name="Ellipse 171"
            cx="3"
            cy="3"
            r="3"
            transform="translate(721 190)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Grill-2"
          data-name="FRT Grill"
          d="M512.789,135.22l2.762,1.925,8.18-.219c6.059-.162,12.152-.136,18.233.027l3.346.09,3.826.1,2.762-1.925c-5.593-.723-19.554-1-19.554-1S518.383,134.5,512.789,135.22Z"
          transform="translate(187.836 58.31)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Grill-3"
          data-name="FRT Grill"
          transform="translate(858 123)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.frt_grill' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(838 122)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.rht_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="127"
          height="18"
          rx="9"
          transform="translate(836 200)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 200)"
        />
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_455"
            data-name="Path 455"
            d="M6157,979.656l41.231,2.416h10.132"
            transform="translate(-5373.362 -772.526)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_175"
            data-name="Ellipse 175"
            cx="3"
            cy="3"
            r="3"
            transform="translate(781 205)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Indicator_lamp-5"
          data-name="RHT  Indicator lamp"
          d="M0,3.423s2.279.386,5.292-1.884L4.018,0A15.753,15.753,0,0,1,0,3.423Z"
          transform="translate(783.095 214.281) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Indicator_lamp-6"
          data-name="RHT  Indicator lamp"
          transform="translate(858 212)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0" xml:space="preserve">
            {{ 'exterior.cargo_van.rht_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(838 211)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_bumper'] || ''"
        [attr.data-name]="'exterior.cargo_van.frt_bumper' | translate"
      >
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="86"
          height="18"
          rx="9"
          transform="translate(840 139)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 139)"
        />
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_453"
            data-name="Path 453"
            d="M6157,1026.487l66.017-46.831h16.223"
            transform="translate(-5404.238 -832.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_173"
            data-name="Ellipse 173"
            cx="3"
            cy="3"
            r="3"
            transform="translate(749 192)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Bumper-2"
          data-name="FRT Bumper"
          d="M397.791,173.278s.6-20.99,13.269-27.062c0,0,11.4-11.994,54.054-11.994S525,146.215,525,146.215s10.279,4.723,12.828,28.262c0,0-1.949-16.417-10.158-22.04s-17.654-13.943-62.857-14.393c0,0-36.208-.9-56.374,14.094C397.775,162.258,397.791,173.278,397.791,173.278Z"
          transform="translate(255.37 58.31)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT Bumper-3"
          data-name="FRT Bumper"
          transform="translate(858 151)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.frt_bumper' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(838 150)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_lft_panel'] || ''"
        [attr.data-name]="'exterior.cargo_van.lft_frt_panel' | translate"
      >
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="119"
          height="18"
          rx="9"
          transform="translate(486 236)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(587 236)"
        />
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_469"
            data-name="Path 469"
            d="M6205.785,995.438l-39.163-15.782H6157"
            transform="translate(-5553.199 -737.318)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_196"
            data-name="Ellipse 196"
            cx="3"
            cy="3"
            r="3"
            transform="translate(650 255)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_FRT_Panel-2"
          data-name="LFT FRT Panel"
          d="M391.712,228.235s-4.273,4.236-4.273,43.817h2.7s-.337-3.936,1.069-4.217c0,0-.956-26.088,4.666-37.108,0,0,1.068-2.024,0-2.811s-2.305,2.642-3.711,8.265l-.9.113Z"
          transform="translate(261.449 3.352)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_FRT_Panel-3"
          data-name="LFT FRT Panel"
          transform="translate(514 248)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.lft_frt_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(589 247)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['driver_door_with_window'] || ''"
        [attr.data-name]="'exterior.cargo_van.lft_driver_door_with_window' | translate"
      >
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="179"
          height="18"
          rx="9"
          transform="translate(425 373)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 373)"
        />
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_473"
            data-name="Path 473"
            d="M6206.2,979.656l-39.494,55.338H6157"
            transform="translate(-5553.199 -652.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_192"
            data-name="Ellipse 192"
            cx="3"
            cy="3"
            r="3"
            transform="translate(650 324)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Driver_Door_with_Window-2"
          data-name="LFT Driver Door with Window"
          d="M387.439,334.989l.825,84.823H397.8s.853-86.06-7.661-84.823Z"
          transform="translate(261.449 -59.585)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(588 384)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Driver_Door_with_Window-3"
          data-name="LFT Driver Door with Window"
          transform="translate(449 385)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.lft_driver_door_with_window' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_r.v_mirror'] || ''"
        [attr.data-name]="'exterior.cargo_van.left_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(498 295)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 295)"
        />
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_471"
            data-name="Path 471"
            d="M6190.092,979.656l-26.565,19H6157"
            transform="translate(-5555.692 -694.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_194"
            data-name="Ellipse 194"
            cx="3"
            cy="3"
            r="3"
            transform="translate(631 282)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="Left_R.V_Mirror_2" data-name="Left R.V Mirror ">
          <path
            id="Path_882"
            data-name="Path 882"
            d="M393.16,345.877s3.673.487,3.861,1.162,1.124-7.721-3.861-7.5Z"
            transform="translate(258.089 -62.264)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_883"
            data-name="Path 883"
            d="M378.059,347.848H383.4v-3.231h-6.859A7.676,7.676,0,0,1,378.059,347.848Z"
            transform="translate(267.849 -65.247)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_884"
            data-name="Path 884"
            d="M341.982,352.608l15.893-4.723s-2.324-5.547-3.748-5.922-12.145,3.373-12.145,3.373-2.249,1.124-1.124,4.2Z"
            transform="translate(288.989 -63.673)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Left_R.V_Mirror_3"
          data-name="Left R.V Mirror "
          transform="translate(510 307)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.left_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(588 306)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['windshield'] || ''"
        [attr.data-name]="'exterior.cargo_van.wind_screen' | translate"
      >
        <path
          id="Path_341"
          data-name="Path 341"
          d="M9.084,0H89.834a9,9,0,1,1,0,18H9.084a9,9,0,1,1,0-18Z"
          transform="translate(504.868 326)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(585.786 326)"
        />
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_472"
            data-name="Path 472"
            d="M6264.162,979.656l-86.023,58.338H6157"
            transform="translate(-5553.199 -703.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_193"
            data-name="Ellipse 193"
            cx="3"
            cy="3"
            r="3"
            transform="translate(708 273)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Wind_Screen-2"
          data-name="Wind Screen"
          d="M462.509,327.779h35.758s2.024,4.348,3.973,4.348l33.509,3.6s3.448.6,3.9-2.849,2.249-26.969,2.249-26.969-.066-10.813-64.465-12.013c0,0-57.88,1.837-58.666,12.013l1.717,26.819a4.064,4.064,0,0,0,4.581,2.474l33.847-3.374Z"
          transform="translate(243.052 -35.46)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(587.786 337)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Wind_Screen-3"
          data-name="Wind Screen"
          transform="translate(522 338)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.wind_screen' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_head_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.lft_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="117"
          height="18"
          rx="9"
          transform="translate(487 166)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 166)"
        />
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_467"
            data-name="Path 467"
            d="M6233.2,1003.016l-61.169-23.36H6157"
            transform="translate(-5553.199 -805.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_198"
            data-name="Ellipse 198"
            cx="3"
            cy="3"
            r="3"
            transform="translate(677 195)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Head_Lamp-2"
          data-name="LFT Head Lamp"
          d="M443.414,149.414s-.5-1.573-1.061-1.789-28.2,4.838-27.743,16.536C414.61,164.161,419.313,154.98,443.414,149.414Z"
          transform="translate(245.496 50.442)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(588 177)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Head_Lamp-3"
          data-name="LFT Head Lamp"
          transform="translate(508 178)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.lft_head_lamp' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.lft_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="123"
          height="18"
          rx="9"
          transform="translate(481 199)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 199)"
        />
        <g class="arrow" id="Arrow-22" data-name="Arrow">
          <path
            id="Path_468"
            data-name="Path 468"
            d="M6218.2,979.656l-49.128,2.208H6157"
            transform="translate(-5553.199 -771.318)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_197"
            data-name="Ellipse 197"
            cx="3"
            cy="3"
            r="3"
            transform="translate(662 206)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Indicator_lamp-2"
          data-name="LFT Indicator lamp"
          d="M414.629,180.2s-.384-2.27,1.878-5.272l1.533,1.27A15.69,15.69,0,0,0,414.629,180.2Z"
          transform="translate(245.496 34.406)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Indicator_lamp-3"
          data-name="LFT Indicator lamp"
          transform="translate(494 211)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.lft_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(588 210)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['logo'] || ''"
        [attr.data-name]="'exterior.cargo_van.logo' | translate"
      >
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="79"
          height="18"
          rx="9"
          transform="translate(525 133)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 133)"
        />
        <g class="arrow" id="Arrow-23" data-name="Arrow">
          <path
            id="Path_466"
            data-name="Path 466"
            d="M6270.2,1029.11l-90.871-49.454H6157"
            transform="translate(-5553.199 -838.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_172"
            data-name="Ellipse 172"
            cx="3"
            cy="3"
            r="3"
            transform="translate(714 188)"
            fill="#696969"
          />
        </g>
        <ellipse
          class="parts"
          id="Logo-2"
          data-name="Logo"
          cx="2.474"
          cy="1.298"
          rx="2.474"
          ry="1.298"
          transform="translate(717.706 192.531)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Logo-3"
          data-name="Logo"
          transform="translate(556 145)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.cargo_van.logo' | translate }}</tspan>
        </text>
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(588 145)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_panel'] || ''"
        [attr.data-name]="'exterior.cargo_van.left_panel' | translate"
      >
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="87"
          height="18"
          rx="9"
          transform="translate(517 407)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 407)"
        />
        <g class="arrow" id="Arrow-24" data-name="Arrow">
          <path
            id="Path_474"
            data-name="Path 474"
            d="M6217.2,1001.317l-48.324-21.662H6157"
            transform="translate(-5553.199 -564.317)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_191"
            data-name="Ellipse 191"
            cx="3"
            cy="3"
            r="3"
            transform="translate(661 434)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Left_Panel-2"
          data-name="Left Panel"
          d="M389.321,540.517l-.082,96.1h.082l-.082,89.058h21.3V540.517Z"
          transform="translate(260.392 -180.291)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Left_Panel-3"
          data-name="Left Panel"
          transform="translate(533 419)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.left_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(588 418)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_r.v_mirror'] || ''"
        [attr.data-name]="'exterior.cargo_van.rht_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="109"
          height="18"
          rx="9"
          transform="translate(836 268)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(836 268)"
        />
        <g class="arrow" id="Arrow-25" data-name="Arrow">
          <path
            id="Path_459"
            data-name="Path 459"
            d="M6157,985.656l22.185-6h5.452"
            transform="translate(-5349.636 -702.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_177"
            data-name="Ellipse 177"
            cx="3"
            cy="3"
            r="3"
            transform="translate(804 280)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="RHT_R.V_Mirror-2" data-name="RHT R.V Mirror">
          <path
            id="Path_885"
            data-name="Path 885"
            d="M736.927,345.877s-3.673.487-3.86,1.162-1.125-7.721,3.86-7.5Z"
            transform="translate(58.589 -62.264)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_886"
            data-name="Path 886"
            d="M748.033,347.848h-5.341v-3.231h6.859A7.677,7.677,0,0,0,748.033,347.848Z"
            transform="translate(52.824 -65.247)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_887"
            data-name="Path 887"
            d="M769.21,352.608l-15.893-4.723s2.324-5.547,3.749-5.922,12.144,3.373,12.144,3.373,2.249,1.124,1.124,4.2Z"
            transform="translate(46.584 -63.673)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="RHT_R.V_Mirror-3"
          data-name="RHT R.V Mirror"
          transform="translate(858 281)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rht_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(838 279)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_bumper'] || ''"
        [attr.data-name]="'exterior.cargo_van.rr_bumper' | translate"
      >
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="115"
          height="18"
          rx="9"
          transform="translate(488 603)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 603)"
        />
        <path
          class="parts"
          id="RR_Bumpher-2"
          data-name="RR Bumpher"
          d="M419.314,1098.379v3.936l11.521,3.748s37.019,1.349,46.614,1.349l52.295-1.8s11.789-3,12.132-3.9V1098.8s-61.728,3.372-64.426,2.264C477.449,1101.061,422.125,1099.841,419.314,1098.379Z"
          transform="translate(242.73 -507.898)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Bumpher-3"
          data-name="RR Bumpher"
          transform="translate(522 615)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.rr_bumper' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(588 614)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g class="arrow" id="Arrow-26" data-name="Arrow">
          <path
            id="Path_479"
            data-name="Path 479"
            d="M6241,979.656l-67.428,10.486H6157"
            transform="translate(-5554 -380.143)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_186"
            data-name="Ellipse 186"
            cx="3"
            cy="3"
            r="3"
            transform="translate(684 597)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['protectives'] || ''"
        [attr.data-name]="'exterior.cargo_van.wiper_blades' | translate"
      >
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="105"
          height="18"
          rx="9"
          transform="translate(499 267)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-29"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 267)"
        />
        <g class="parts" id="Wiper_Blades-2" data-name="Protectives">
          <path
            id="Path_874"
            data-name="Path 874"
            d="M431.3,284.992a2.506,2.506,0,0,0,2.329,1.3c1.743,0,9.671-.652,9.671-.652v1.495s-15.686,2.305-16.811,1.855a5.908,5.908,0,0,1-1.753-1.049Z"
            transform="translate(239.544 -30.232)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_875"
            data-name="Path 875"
            d="M469.715,284.639l16.7-1.753,2.136,2.03s-12.912,1.185-14.711,2.384l-.15,1.649,41.456-3.032v-1s-14.908-1.379-24.4-.277l-3.936-3.232-17.092,2.131Z"
            transform="translate(213.132 -28.126)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_876"
            data-name="Path 876"
            d="M557.652,269.936s.323,2.237,2.032,2.58,9.61,1.259,9.61,1.259l-.062.308L569,275.24s-15.732-1.623-16.746-2.285a31.1,31.1,0,0,1-3.262-3.019Z"
            transform="translate(166.575 -21.39)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_877"
            data-name="Path 877"
            d="M597.656,280.316l16.717,1.559,1.7,2.41s-12.894-1.373-14.894-.55l-.471,1.588,41.244,5.163.2-.982s-14.347-4.278-23.872-5.061L615.05,280.5l-17.178-1.265Z"
            transform="translate(137.998 -26.852)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Wiper_Blades-3"
          data-name="Protectives"
          transform="translate(519 279)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.wiper_blades' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-29"
          data-name="3.0"
          transform="translate(588 278)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g class="arrow" id="Arrow-27" data-name="Arrow">
          <path
            id="Path_470"
            data-name="Path 470"
            d="M6249.91,979.656l-74.583,24.338H6157"
            transform="translate(-5553.199 -725.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_195"
            data-name="Ellipse 195"
            cx="3"
            cy="3"
            r="3"
            transform="translate(694 251)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.cargo_van.lft_rr_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-29"
          data-name="Rectangle 38"
          width="130"
          height="18"
          rx="9"
          transform="translate(471 476)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-30"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(586 476)"
        />
        <g class="arrow" id="Arrow-28" data-name="Arrow">
          <path
            id="Path_476"
            data-name="Path 476"
            d="M6217.2,1076.317l-48.324-96.661H6157"
            transform="translate(-5553.199 -494.317)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_189"
            data-name="Ellipse 189"
            cx="3"
            cy="3"
            r="3"
            transform="translate(661 579)"
            fill="#696969"
          />
        </g>
        <text
          id="LFT_Indicator_lamp-5"
          data-name="LFT RR Indicator lamp"
          transform="translate(480 488)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.cargo_van.lft_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-30"
          data-name="3.0"
          transform="translate(588 487)"
          fill="#030303"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <path
          class="parts"
          id="LFT_Indicator_lamp-6"
          data-name="LFT RR Indicator lamp"
          d="M424.507,1080.608v-6.522h1.8v-3.223H413.029v5.772s.375,3.715,3.715,3.715Z"
          transform="translate(246.421 -491.74)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
      </g>
    </g>
  </svg>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : {{ 'exterior.qc_passed' | translate }}
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : {{ 'exterior.qc_failed' | translate }}
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>

    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part change)</option>
                <option [value]="2">2 (Major Repair)</option>
                <option [value]="3">3 (Moderate Repair)</option>
                <option [value]="4">4 (Minor Repair)</option>
                <option [value]="5">5 (Good part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <!-- <label class="modal_car_input_label">Description</label> -->
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="
            !vehicleStatus &&
            ((editableRole.includes(role) && role !== 'estimator') ||
              ['qc', 'evaluator'].includes(role))
          "
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn-primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
